import * as actionTypes from "./actions";

const initialState = {
  formSelectionData: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_FORM_SELECTION_DATA:
      return {
        ...state,
        formSelectionData: action.payload
      };
    case actionTypes.CLEAR_FORM_SELECTION_DATA:
      return {
        ...state,
        formSelectionData: null
      };
    default:
      return state;
  }
};

export default reducer;
